import { makeRequest } from "../http-common";

const ReportDataService = {
  async getRecentLogins() {
    return makeRequest("get", `/reports/recent-logins`);
  },

  async getUserSummary() {
    return makeRequest("get", `/reports/user-summary`);
  },

  async getUserActivity(user,type,actions,date){
    return makeRequest("get", `/reports/user-activity/${user}/${type}/${actions}/${date}`);
  },

  async getUsersPolicySummary() {
    return makeRequest("get", `/reports/user-policy-summary`);
  },

  // '/total-premium-volume/:start/:end/:status/:business/:coverage/:groupby/:breakpoint'

  async getTotalPremiumVolume(start,end,status,business,coverage,groupby,breakpoint) {
    return makeRequest("get", `/reports/total-premium-volume/${start}/${end}/${status}/${business}/${coverage}/${groupby}/${breakpoint}`);
  },

};

export default ReportDataService;
